import { render, staticRenderFns } from "./ClinicHisDic.vue?vue&type=template&id=6894a052"
import script from "./ClinicHisDic.vue?vue&type=script&lang=js"
export * from "./ClinicHisDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicHisDic.vue?vue&type=style&index=0&id=6894a052&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6894a052')) {
      api.createRecord('6894a052', component.options)
    } else {
      api.reload('6894a052', component.options)
    }
    module.hot.accept("./ClinicHisDic.vue?vue&type=template&id=6894a052", function () {
      api.rerender('6894a052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicHisDic.vue"
export default component.exports